import React from "react";
import "../styles/WorkExperience.css";

const WorkExperience = () => {
  const experiences = [
    {
      title: "Research Software Developer",
      company: "University at Buffalo – OneDataShare.org",
      duration: "2024 – Present",
      description:
        "Integration of MinIO storage using Spring Batch within a microservice-based system.",
      skills: ["Java", "Spring Boot", "Spring Batch", "AWS", "MinIO", "Microservices", "Cloud APIs"],
    },
    {
      title: "Software Engineer",
      company: "Oxane Partners",
      duration: "2021 – 2023",
      description:
        "Contributed to building enterprise financial platforms. Engineered reusable Java and ReactJS components and backend systems tailored for diverse asset classes.",
      skills: ["Java", "Python", "React", "Highcharts", "SQL", "Django"],
    },
    {
      title: "Software Engineer Intern",
      company: "NTPC Ltd.",
      duration: "2018",
      description:
        "Developed React.js–based plant monitoring dashboards at NTPC using Redux and Elasticsearch telemetry indices, enabling real-time fuel and generation analytics.",
      skills: ["AWS", "React", "Java", "Firebase", "Chart.js"],
    },
  ];

  return (
    <div className="work-experience">
      <h2>Work Experience</h2>
      {experiences.map((exp, index) => (
        <div key={index} className="experience-card">
          <h3>
            {exp.title} <span>@ {exp.company}</span>
          </h3>
          <p className="experience-duration">{exp.duration}</p>
          <p className="experience-description">{exp.description}</p>
          <div className="experience-skills">
            {exp.skills.map((skill, idx) => (
              <span key={idx} className="skill-badge">{skill}</span>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default WorkExperience;
